import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    // Vérifier si l'utilisateur est connecté
    if (!this.authService.isLoggedIn()) {
      return this.router.createUrlTree(['/auth/login']);
    }

    // Récupérer les rôles requis depuis les données de route
    const requiredRoles = route.data['roles'] as string[];
    const requiredPermissions = route.data['permissions'] as string[];

    // Vérifier les rôles si spécifiés
    if (requiredRoles && requiredRoles.length > 0) {
      if (!this.authService.hasAnyRole(requiredRoles)) {
        // Rediriger vers une page d'accès refusé
        return this.router.createUrlTree(['/access-denied']);
      }
    }

    // Vérifier les permissions si spécifiées
    if (requiredPermissions && requiredPermissions.length > 0) {
      for (const permission of requiredPermissions) {
        if (!this.authService.hasPermission(permission)) {
          // Rediriger vers une page d'accès refusé
          return this.router.createUrlTree(['/access-denied']);
        }
      }
    }

    // Lot 1 — modules (en plus du rôle)
    const requiredModules = route.data['modules'] as string[] | undefined;
    if (requiredModules && requiredModules.length > 0) {
      const requireAll = !!route.data['requireAllModules'];
      const ok = requireAll
        ? this.authService.hasAllModules(requiredModules)
        : this.authService.hasAnyModule(requiredModules);
      if (!ok) {
        return this.router.createUrlTree(['/access-denied']);
      }
    }

    return true;
  }
} 